module.exports = __webpack_public_path__ + "img/image04.fdf4d396.jpg";